import { useProfile } from "@brg/auth"
import { useIsMobile, useToasts } from "@brg/ui"
import { useModal } from "core"
import {SyntheticEvent, useCallback, useEffect, useRef, useState} from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentContextName } from "supporting"
import {AvailableTariff} from "../../../constants/types";
import {EntityPaymentTypes} from "../../../constants/payment";
import {
    calculateCustomPrise,
    getAvailableTariffs,
    selectorOrder,
    setActiveTariff,
    setAvailableTariffs,
    setImmediatePurchaseProps
} from "../../../slices/OrderSlice";
import {cardStatus} from "../../../constants/cardInfo";
import economicUrlApi from "../../../helpers/economicUrlApi";
import { SequenceInfo } from "@brg/api/dist/api-core/types/economics/SequenceInfo"
import { CurrencyType } from "@brg/api"

interface UseTariff {

}

export const useTariffs = (props: UseTariff) => {
    const { } = props
    const dispatch = useDispatch()
    const modal = useModal()
    const { t, i18n } = useTranslation()
    const { error, info } = useToasts();
    const profile = useProfile()
    const isMobile = useIsMobile()
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError, immediatePurchaseProps, bookCard, bookCardT } = useSelector(selectorOrder)
    const [sequenceInfo, setSequenceInfo] = useState<SequenceInfo | null>(null);
    const sequenceId = bookCard?.sequenceItem?.sequenceId;
    const sequenceInfoErr = useRef<any>({});

    useEffect(() => {
        return () => {
            setActiveTariff(null);
            setAvailableTariffs(null);
            setSequenceInfo(null);
        }
    }, []);

    const contextName = getCurrentContextName()
    const productEntityType = EntityPaymentTypes.book
    useEffect(() => {
        if(availableTariffs?.length || productEntityType === EntityPaymentTypes.book) {
            return
        }
        dispatch(getAvailableTariffs({entityType: productEntityType}))
    }, [])

    useEffect(() => {
        if (productEntityType !== EntityPaymentTypes.book || !bookCard?.cardId) {
            return
        }
        dispatch(getAvailableTariffs({entityType: productEntityType, bookCardId: bookCard?.cardId}))
    }, [bookCard?.cardId, bookCardT])

    useEffect(() => {
        const fetchSequenceInfoAsync = async () => {
            try {
                const sequenceInfoRequest: any = await economicUrlApi().getSequenceInfo({ id: sequenceId });
                if (sequenceInfoRequest?.id) {
                    setSequenceInfo(sequenceInfoRequest)
                }
            } catch (err: any) {
                console.error('getSequenceInfo err:', err);
                sequenceInfoErr.current[sequenceId] = err
            }
        };
        if (!sequenceId || sequenceInfoErr?.current[sequenceId]) {
            return;
        }
        fetchSequenceInfoAsync();
    }, [sequenceId]);

    const onChangeTariff = useCallback((newTariff: AvailableTariff) => () => {
        dispatch(setActiveTariff(newTariff))
    }, [])

    const changePrice = (priceType: 'userPrice' | 'creatingPrice') => async (e: SyntheticEvent<HTMLInputElement>) => {
        try {
            //@ts-ignore
            const newPrice: string = e.target.value
            dispatch(setActiveTariff({ ...activeTariff, [priceType]: newPrice }))
            const priceTypeKey = priceType === 'userPrice' ? 'customUserPrice' : 'customCreatingPrice'
            const calculatedTariffRequest = await dispatch(calculateCustomPrise({
                entityType: productEntityType,
                [priceTypeKey]: newPrice,
            }))
            //@ts-ignore
            const calculatedTariff: AvailableTariff = calculatedTariffRequest?.payload?.data
            if (calculatedTariff) {
                dispatch(setActiveTariff(calculatedTariff))
            }
        } catch (err: any) {
            error(err.message)
            console.error('changePrice err:', err);
        }
    }

    const onPay = useCallback(async () => {
        try {
            const createdCardRequest = immediatePurchaseProps?.productId && null
            //@ts-ignore
            const createdCard = createdCardRequest?.payload
            if (createdCard?.cardId && !createdCard?.images?.length) {
                error(t('upload images'))
                return 
            }
            if (createdCard?.cardId && createdCard?.images?.length && (createdCard?.statusCard === cardStatus.awaitPayment) && (contextName !== 'artz')) {
                dispatch(setImmediatePurchaseProps({
                    productId: createdCard?.cardId,
                    paymentEntityType: EntityPaymentTypes.card,
                    //TODO - завязаться на реальную цену
                    price: 100,
                    tariff: activeTariff,
                    productInfo: {
                        id: createdCard?.cardId,
                        preview: createdCard?.images,
                        name: createdCard?.name,
                        summary: {
                            "Print quality": createdCard?.printQuality,
                            "Orientation": createdCard?.orientation ? "horizontal" : "vertical"
                        }
                    },
                    currencyType: CurrencyType.RealMoney,
                }))
                modal.show("checkout", {
                    productId: createdCard?.cardId,
                    paymentEntityType: EntityPaymentTypes.card,
                    productInfo: {
                        preview: createdCard?.images,
                        name: createdCard?.name,
                        summary: {
                            "Print quality": createdCard?.printQuality,
                            "Orientation": createdCard?.orientation ? "horizontal" : "vertical"
                        }
                    },
                    handleClick: (e: any) => {
                        console.log('on ok click', e);
                        info(t('buy.card_will_queued'))
                    },
                    close: (e: any) => {
                        console.log('on close click', e);
                    },
                    onPaymentSuccess: () => {
                        if (!profile?.accountId) {
                            return
                        }
                    }
                })
            }
        } catch (error) {
                
        }
    }, [immediatePurchaseProps])

    return { changePrice, onPay, onChangeTariff, sequenceInfo }
}import { useProfile } from "@brg/auth"
import { useIsMobile, useToasts } from "@brg/ui"
import { useModal } from "core"
import {SyntheticEvent, useCallback, useEffect, useRef, useState} from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentContextName } from "supporting"
import {AvailableTariff} from "../../../constants/types";
import {EntityPaymentTypes} from "../../../constants/payment";
import {
    calculateCustomPrise,
    getAvailableTariffs,
    selectorOrder,
    setActiveTariff,
    setAvailableTariffs,
    setImmediatePurchaseProps
} from "../../../slices/OrderSlice";
import {cardStatus} from "../../../constants/cardInfo";
import economicUrlApi from "../../../helpers/economicUrlApi";
import { SequenceInfo } from "@brg/api/dist/api-core/types/economics/SequenceInfo"
import { CurrencyType } from "@brg/api"

interface UseTariff {

}

export const useTariffs = (props: UseTariff) => {
    const { } = props
    const dispatch = useDispatch()
    const modal = useModal()
    const { t, i18n } = useTranslation()
    const { error, info } = useToasts();
    const profile = useProfile()
    const isMobile = useIsMobile()
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError, immediatePurchaseProps, bookCard, bookCardT } = useSelector(selectorOrder)
    const [sequenceInfo, setSequenceInfo] = useState<SequenceInfo | null>(null);
    const sequenceId = bookCard?.sequenceItem?.sequenceId;
    const sequenceInfoErr = useRef<any>({});

    useEffect(() => {
        return () => {
            setActiveTariff(null);
            setAvailableTariffs(null);
            setSequenceInfo(null);
        }
    }, []);

    const contextName = getCurrentContextName()
    const productEntityType = EntityPaymentTypes.book
    useEffect(() => {
        if(availableTariffs?.length || productEntityType === EntityPaymentTypes.book) {
            return
        }
        dispatch(getAvailableTariffs({entityType: productEntityType}))
    }, [])

    useEffect(() => {
        if (productEntityType !== EntityPaymentTypes.book || !bookCard?.cardId) {
            return
        }
        dispatch(getAvailableTariffs({entityType: productEntityType, bookCardId: bookCard?.cardId}))
    }, [bookCard?.cardId, bookCardT])

    useEffect(() => {
        const fetchSequenceInfoAsync = async () => {
            try {
                const sequenceInfoRequest: any = await economicUrlApi().getSequenceInfo({ id: sequenceId });
                if (sequenceInfoRequest?.id) {
                    setSequenceInfo(sequenceInfoRequest)
                }
            } catch (err: any) {
                console.error('getSequenceInfo err:', err);
                sequenceInfoErr.current[sequenceId] = err
            }
        };
        if (!sequenceId || sequenceInfoErr?.current[sequenceId]) {
            return;
        }
        fetchSequenceInfoAsync();
    }, [sequenceId]);

    const onChangeTariff = useCallback((newTariff: AvailableTariff) => () => {
        dispatch(setActiveTariff(newTariff))
    }, [])

    const changePrice = (priceType: 'userPrice' | 'creatingPrice') => async (e: SyntheticEvent<HTMLInputElement>) => {
        try {
            //@ts-ignore
            const newPrice: string = e.target.value
            dispatch(setActiveTariff({ ...activeTariff, [priceType]: newPrice }))
            const priceTypeKey = priceType === 'userPrice' ? 'customUserPrice' : 'customCreatingPrice'
            const calculatedTariffRequest = await dispatch(calculateCustomPrise({
                entityType: productEntityType,
                [priceTypeKey]: newPrice,
            }))
            //@ts-ignore
            const calculatedTariff: AvailableTariff = calculatedTariffRequest?.payload?.data
            if (calculatedTariff) {
                dispatch(setActiveTariff(calculatedTariff))
            }
        } catch (err: any) {
            error(err.message)
            console.error('changePrice err:', err);
        }
    }

    const onPay = useCallback(async () => {
        try {
            const createdCardRequest = immediatePurchaseProps?.productId && null
            //@ts-ignore
            const createdCard = createdCardRequest?.payload
            if (createdCard?.cardId && !createdCard?.images?.length) {
                error(t('upload images'))
                return 
            }
            if (createdCard?.cardId && createdCard?.images?.length && (createdCard?.statusCard === cardStatus.awaitPayment) && (contextName !== 'artz')) {
                dispatch(setImmediatePurchaseProps({
                    productId: createdCard?.cardId,
                    paymentEntityType: EntityPaymentTypes.card,
                    //TODO - завязаться на реальную цену
                    price: 100,
                    tariff: activeTariff,
                    productInfo: {
                        id: createdCard?.cardId,
                        preview: createdCard?.images,
                        name: createdCard?.name,
                        summary: {
                            "Print quality": createdCard?.printQuality,
                            "Orientation": createdCard?.orientation ? "horizontal" : "vertical"
                        }
                    },
                    currencyType: CurrencyType.RealMoney,
                }))
                modal.show("checkout", {
                    productId: createdCard?.cardId,
                    paymentEntityType: EntityPaymentTypes.card,
                    productInfo: {
                        preview: createdCard?.images,
                        name: createdCard?.name,
                        summary: {
                            "Print quality": createdCard?.printQuality,
                            "Orientation": createdCard?.orientation ? "horizontal" : "vertical"
                        }
                    },
                    handleClick: (e: any) => {
                        console.log('on ok click', e);
                        info(t('buy.card_will_queued'))
                    },
                    close: (e: any) => {
                        console.log('on close click', e);
                    },
                    onPaymentSuccess: () => {
                        if (!profile?.accountId) {
                            return
                        }
                    }
                })
            }
        } catch (error) {
                
        }
    }, [immediatePurchaseProps])

    return { changePrice, onPay, onChangeTariff, sequenceInfo }
}